import { Card } from "antd";
import React from "react";
import ContentLoader from "react-content-loader";

interface IProps {
    className?: string;
}

export const DownloadsSkeleton: React.FC<IProps> = (props) => (
    <Card className="newUI-subtle white">
        <ContentLoader viewBox="0 0 395 125" height={125} width={395} {...props}>
            <circle cx="350" cy="20" r="16" />
            <rect x="10" y="20" rx="5" ry="5" width="220" height="10" />
            <rect x="10" y="40" rx="5" ry="5" width="220" height="10" />
            <rect x="10" y="60" rx="5" ry="5" width="220" height="10" />
            <rect x="10" y="80" rx="5" ry="5" width="220" height="10" />
            <rect x="335" y="90" rx="10" ry="10" width="32" height="32" />
        </ContentLoader>
    </Card>
);
